/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EBIcon,
  EBIcon$inboundSchema,
  EBIcon$Outbound,
  EBIcon$outboundSchema,
} from "./ebicon.js";

/**
 * Specifies details for an icon shelf that is shown below an Animatic Card.
 */
export type AnimaticIconShelf = {
  /**
   * The icons to display on the shelf
   */
  icons: Array<EBIcon>;
};

/** @internal */
export const AnimaticIconShelf$inboundSchema: z.ZodType<
  AnimaticIconShelf,
  z.ZodTypeDef,
  unknown
> = z.object({
  icons: z.array(EBIcon$inboundSchema),
});
/** @internal */
export type AnimaticIconShelf$Outbound = {
  icons: Array<EBIcon$Outbound>;
};

/** @internal */
export const AnimaticIconShelf$outboundSchema: z.ZodType<
  AnimaticIconShelf$Outbound,
  z.ZodTypeDef,
  AnimaticIconShelf
> = z.object({
  icons: z.array(EBIcon$outboundSchema),
});

export function animaticIconShelfToJSON(
  animaticIconShelf: AnimaticIconShelf,
): string {
  return JSON.stringify(
    AnimaticIconShelf$outboundSchema.parse(animaticIconShelf),
  );
}
export function animaticIconShelfFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticIconShelf, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticIconShelf$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticIconShelf' from JSON`,
  );
}
